import React, { useContext, useEffect } from "react";
import styled from 'styled-components';
import PlayerControls from "./PlayerControls";
import {ProgressBar} from "./ProgressBar";
import {TrackTime} from "./TrackTime";
import {AudioPlayerContext} from "./AudioPlayerContext";

function AudioPlayer() {
  const { audioRef, selectedFile, setTrackProgress, isPlaying, wantsToPlay, setIsReady, play,
    stop } = useContext(AudioPlayerContext);

  if (!selectedFile) return null;

  const handleCanPlayThrough = () => {
    if (wantsToPlay && !isPlaying) play();
  }

  return (
    <>
      <AudioPlayerControlsWrapper>
        <PlayerControls />
        <ProgressBar />
        <TrackTime />
      </AudioPlayerControlsWrapper>

      <audio
        ref={audioRef}
        src={selectedFile.src}
        onEnded={stop}
        onTimeUpdate={() => setTrackProgress(audioRef.current.currentTime)}
        onCanPlay={handleCanPlayThrough}
        onLoadedMetadata={() => {
          setIsReady(true);
          handleCanPlayThrough();
        }
      }
      >
        <track kind="metadata"/>
        <p>Your browser does not support the
          <code>audio</code> element.</p>
      </audio>

    </>
  )
}

const AudioPlayerControlsWrapper = styled.div`
  height: 26px;
  display: flex;
  align-items: center;
  gap: 1.5rem;
  padding: 1rem;
  background-color: #E8E4DC;
`;

export default AudioPlayer;
